const ACTIONS = {
    FETCH_REVIEWS_REQUEST_STARTED: 'REVIEWS/FETCH_REQUEST_STARTED',
    FETCH_REVIEWS_SUCCESS: 'REVIEWS/FETCH_SUCCESS',
    FETCH_REVIEWS_FAILURE: 'REVIEWS/FETCH_FAILURE',
    EXPAND_REVIEW_CLICKED: 'REVIEWS/EXPAND_REVIEW_CLICKED',
    SCROLL_REVIEWS_TOP: 'REVIEWS/SCROLL_REVIEWS_TOP',
    SET_PAGE_INDEX: 'REVIEWS/SET_PAGE_INDEX',
    VIEW_ALL_REVIEWS: 'REVIEWS/VIEW_ALL_REVIEWS',
    PREV_PAGE: 'REVIEWS/PREV_PAGE',
    NEXT_PAGE: 'REVIEWS/NEXT_PAGE',
    REPORT_REVIEW_CLICKED: 'REVIEWS/REPORT_REVIEW_CLICKED'
};

const ACTION_CREATORS = {
    fetchReviewsStarted(isFetching = true) {
        return {
            type: ACTIONS.FETCH_REVIEWS_REQUEST_STARTED,
            payload: {
                isFetching
            }
        };
    },
    fetchReviewsFailure(error) {
        return {
            type: ACTIONS.FETCH_REVIEWS_FAILURE,
            payload: {
                error,
                isFetching: false
            }
        };
    },
    fetchReviewsSuccess({reviews} = {}) {
        return {
            type: ACTIONS.FETCH_REVIEWS_SUCCESS,
            payload: {
                reviews,
                isFetching: false
            }
        };
    },
    expandReviewClicked(reviewId) {
        return {
            type: ACTIONS.EXPAND_REVIEW_CLICKED,
            payload: {
                reviewId
            }
        };
    },
    setPageIndex(pageIndex) {
        return {
            type: ACTIONS.SET_PAGE_INDEX,
            payload: {pageIndex}
        };
    },
    nextPage() {
        return {
            type: ACTIONS.NEXT_PAGE,
            payload: {}
        };
    },
    prevPage() {
        return {
            type: ACTIONS.PREV_PAGE,
            payload: {}
        };
    },
    scrollTop(scrollTop) {
        return {
            type: ACTIONS.SCROLL_REVIEWS_TOP,
            payload: {scrollTop}
        };
    },
    viewAllReviews(selectedReviewUuid) {
        return {
            type: ACTIONS.VIEW_ALL_REVIEWS,
            payload: {uuid: selectedReviewUuid}
        };
    },
    reportReviewClicked(reviewId) {
        return {
            type: ACTIONS.REPORT_REVIEW_CLICKED,
            payload: {reviewId}
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
